import { useEffect, useRef } from 'react';

/**
 * Brief description of the function here.
 * @summary save state as previous state for future use (e.g. comparing state)
 * @useCase const [glossaryTerms, setGlossaryTerms] = useState([]);
 * const prevGlossaryTerms = usePreviousState(glossaryTerms);
 * if (prevGlossaryTerms !== glossaryTerms) {
 * do something
 * }
 * @param {any} value - state to be saved as previous state.
 * @returns {any} - previous state
 */

const usePreviousState = (value): any => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePreviousState;
